// extracted by mini-css-extract-plugin
export default {"image":"BaseImage-19aYC__image"};